/* ============================================================================
   Quote Calculator — Instant Balustrade Quote
   Vanilla JS rewrite of the legacy jQuery/Neto calculator.
   Calculation logic, conditions, wire/swaging rules and combo pairing are
   ported 1:1; cart add uses Shopify's /cart/add.js.
   ============================================================================ */
(function () {
  'use strict';

  /* ---- Static configuration (ported verbatim from the legacy SKUs) -------- */
  var CONFIG = {
    wireDefault: 'WRS119316-032-MTR',
    wireCustom:  'WRS77316-032-MTR',   // DIY systems
    wireCustom2: 'BWRS119316-032-MTR', // WBSB (black) systems
    swaging:     'S03',

    // System pools keyed by  post(1=timber,2=metal) + '-' + layout(1=flat,2=stair,3=combo)
    pools: {
      '1-1': ['WBS-RFSE','WBSB-TTS','WBSB-RFSE','WBSB-RFSAD','WBSB-LSS','WBSB-TIS','WBS-LSS','WBS-RFSAD','WBS-TIS','WBS-TTS','WBS-DIYTB','WBS-DIYRS'],
      '2-1': ['WBS-RFNS','WBS-RFSAD-M','WBSB-MIS','WBSB-RFNS','WBSB-RFSAD-M','WBS-TLS','WBSB-TLS','WBS-MIS','WBS-TTS','WBSB-TTS','WBS-DIYTB-M','WBS-DIYRS-M'],
      '1-2': ['WBS-RFSE','WBSB-RFSE','WBSB-RFSAD','WBS-TTSS','WBSB-TTSS','WBS-TISS','WBSB-TISS','WBS-RFSAD','WBS-DIYTB','WBS-DIYRS'],
      '2-2': ['WBS-TTSS','WBSB-TTSS','WBS-RFNS','WBS-RFSAD-M','WBSB-RFNS','WBSB-RFSAD-M','WBS-MISS','WBSB-MISS','WBS-TLS','WBSB-TLS','WBS-DIYTB-M','WBS-DIYRS-M'],
      '1-3': ['WBS-RFSE','WBSB-RFSE','WBSB-RFSAD','WBS-RFSAD','WBS-TIS','WBS-TTS','WBS-DIYTB','WBS-DIYRS','WBSB-TIS','WBSB-TTS'],
      '2-3': ['WBS-RFNS','WBSB-RFNS','WBS-RFSAD-M','WBSB-RFSAD-M','WBS-MIS','WBS-TTS','WBS-TLS','WBSB-TLS','WBS-DIYTB-M','WBS-DIYRS-M','WBSB-MIS','WBSB-TTS']
    },

    customWire:  ['WBS-DIYRS-M','WBS-DIYRS','WBS-DIYTB','WBS-DIYTB-M'],
    customWire2: ['WBSB-LSS','WBSB-MIS','WBSB-RFNS','WBSB-RFSAD','WBSB-RFSAD-M','WBSB-RFSE','WBSB-TIS','WBSB-TTS','WBSB-TLS','WBSB-TTSS','WBSB-TISS','WBSB-MISS'],
    noSwaging:   ['WBS-DIYTB','WBS-DIYRS','WBS-DIYTB-M','WBS-DIYRS-M'],

    // Flat -> stair counterpart for combo layouts (else system pairs to itself)
    stairPair: {
      'WBS-TIS':  'WBS-TISS',
      'WBS-TTS':  'WBS-TTSS',
      'WBS-MIS':  'WBS-MISS',
      'WBSB-MIS': 'WBSB-MISS',
      'WBSB-TIS': 'WBSB-TISS',
      'WBSB-TTS': 'WBSB-TTSS'
    },

    shortMax: ['WBS-LSS','WBSB-LSS'], // 6,000 mm max length (others 10,000 mm)

    LENGTH_MIN: 400,
    LENGTH_MAX: 10000,
    LENGTH_MAX_SHORT: 6000,
    TOTAL_STEPS: 7
  };

  function money(n) {
    return '$' + (Number(n) || 0).toFixed(2);
  }
  function inList(list, value) {
    return list.indexOf(value) !== -1;
  }

  // Fallback thumbnail icon — shown when a line item has no product image (e.g.
  // wire/swaging utility products) or when the image URL fails to load.
  var THUMB_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
    '<circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';

  // Layered cell: placeholder always present; the image (if any) sits on top and
  // removes itself on error, revealing the icon underneath.
  function thumbCell(image) {
    var ph = '<span class="qc-summary-ph" aria-hidden="true">' + THUMB_ICON + '</span>';
    var img = image
      ? '<img class="qc-summary-thumb" src="' + image + '" alt="" width="48" height="48" ' +
        'loading="lazy" onerror="this.remove()">'
      : '';
    return ph + img;
  }

  /* ======================================================================== */
  function QuoteCalculator(root) {
    this.root = root;
    /* GST label ("Inc GST" / "Ex GST") is resolved once from the customer's tag
       in Liquid (snippets/awr-gst-label.liquid) and passed in on the root. */
    this.gstLabel = root.getAttribute('data-gst-label') || 'Inc GST';
    /* Display-only GST multiplier: retail shows prices × 1.1 (Inc GST). The raw
       values still drive cart add + BSS quote submission unchanged. */
    this.gstMul = parseFloat(root.getAttribute('data-gst-mul')) || 1;
    this.state = {
      step: 1,
      post: 0, layout: 0,
      system: '', system2: '',
      wire: 0, wire1: 0, wire2: 0,
      wireQty1: 0, wireQty2: 0, wireHeight: 0, wireSubtrahend: 1,
      manualQuote: false
    };
    this.lineItems = [];
    this.skuMap = {};        // sku -> { variantId, price, name, available }
    this.buildSkuMap();
    this.bind();
    this.refresh();
    this.ensurePricingData();  // top up any pricing SKU sitting past the 50-product Liquid cap
  }

  QuoteCalculator.prototype.$  = function (sel) { return this.root.querySelector(sel); };
  QuoteCalculator.prototype.$$ = function (sel) { return Array.prototype.slice.call(this.root.querySelectorAll(sel)); };

  /* ---- Product data lookup ------------------------------------------------ */
  QuoteCalculator.prototype.buildSkuMap = function () {
    var self = this;
    /* Prices come straight from Liquid (quote-product.liquid), which reads each
       variant's SAWholesale price_ metafield for the logged-in customer. This store
       uses exact per-variant B2B prices (not a uniform % off), so we trust the
       Liquid-rendered data-price / data-compare-price verbatim — no client-side math.
       Utility SKUs past the 50-product cap reach Liquid via the paginated scan in
       quote-form.liquid, so they carry correct B2B prices too.                      */
    this.$$('.qc-product').forEach(function (el) {
      var sku = el.getAttribute('data-sku');
      if (!sku) return;
      var price   = parseFloat(el.getAttribute('data-price'))         || 0;
      var compare = parseFloat(el.getAttribute('data-compare-price')) || price;
      if (compare < price) compare = price;   // never show a compare below the sell price

      self.skuMap[sku] = {
        variantId: el.getAttribute('data-variant-id'),
        productId: el.getAttribute('data-product-id') || '',
        price: price,
        comparePrice: compare,
        name: el.getAttribute('data-name') || sku,
        image: el.getAttribute('data-image') || '',
        available: el.getAttribute('data-available') === 'true'
      };
    });
  };

  /* ---- Top up pricing SKUs that sit past the 50-product Liquid cap ---------
     Liquid's collection.products only renders the first 50 products, so a pricing
     SKU (wire / swaging) sorted past #50 never reaches skuMap and shows as $0.
     We only need a handful of known SKUs, so if any are missing we fetch the
     collection's public products.json (paged, not capped at 50) and fill the gaps.
     Purely additive — Liquid-provided entries are never overwritten.            */
  QuoteCalculator.prototype.requiredSkus = function () {
    return [CONFIG.wireDefault, CONFIG.wireCustom, CONFIG.wireCustom2, CONFIG.swaging];
  };
  QuoteCalculator.prototype.missingSkus = function () {
    var self = this;
    return this.requiredSkus().filter(function (sku) { return !self.skuMap[sku]; });
  };
  QuoteCalculator.prototype.ensurePricingData = function () {
    var self = this;
    var missing = this.missingSkus();
    if (!missing.length) return;

    var handle = this.root.getAttribute('data-pricing-handle')
              || this.root.getAttribute('data-collection-handle');
    if (!handle) { this.warnMissing(missing); return; }

    /* Last-resort fallback only — the paginated Liquid scan in quote-form.liquid
       should already cover every utility SKU with its correct B2B price. If a SKU
       still slipped through, products.json has no customer context, so we can only
       fill in retail price (no fake discount — that would mislead the quote).     */
    var page = 1, MAX_PAGES = 10;
    function fetchPage() {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var products = data && data.products ? data.products : [];
          products.forEach(function (p) {
            var img = (p.images && p.images.length) ? p.images[0] : '';
            (p.variants || []).forEach(function (v) {
              if (!v.sku || self.skuMap[v.sku]) return;   // keep Liquid data authoritative
              var basePrice = parseFloat(v.price) || 0;    // products.json prices are major-unit strings ("11.54")
              self.skuMap[v.sku] = {
                variantId: String(v.id),
                price: basePrice,
                comparePrice: basePrice,
                name: p.title || v.sku,
                image: img,
                available: v.available !== false
              };
            });
          });
          var stillMissing = self.missingSkus();
          var more = products.length >= 250 && page < MAX_PAGES;
          if (stillMissing.length && more) { page++; fetchPage(); return; }
          self.refresh();                                 // re-price now the data is in
          self.warnMissing(stillMissing);
        })
        .catch(function () { self.warnMissing(self.missingSkus()); });
    }
    fetchPage();
  };
  QuoteCalculator.prototype.warnMissing = function (missing) {
    if (!missing || !missing.length) return;
    console.warn('[QuoteCalculator] Pricing SKUs still unresolved (will price at $0): '
      + missing.join(', ')
      + '. Confirm these products are Active and in the calculator collection.');
  };
  QuoteCalculator.prototype.priceOf = function (sku) { return this.skuMap[sku] ? this.skuMap[sku].price : 0; };
  QuoteCalculator.prototype.nameOf  = function (sku) { return this.skuMap[sku] ? this.skuMap[sku].name : sku; };

  /* ---- Event wiring ------------------------------------------------------- */
  QuoteCalculator.prototype.bind = function () {
    var self = this;

    // Post / Layout / System selection (event delegation)
    this.root.addEventListener('click', function (e) {
      var postCard = e.target.closest('[data-post]');
      if (postCard && self.root.contains(postCard)) { self.selectPost(+postCard.getAttribute('data-post')); return; }

      var layoutCard = e.target.closest('[data-layout]');
      if (layoutCard && self.root.contains(layoutCard)) { self.selectLayout(+layoutCard.getAttribute('data-layout')); return; }

      var product = e.target.closest('.qc-product');
      if (product && !product.classList.contains('qc-product--utility') && !e.target.closest('a')) {
        self.selectSystem(product.getAttribute('data-sku')); return;
      }

      var wireBtn = e.target.closest('[data-wire]');
      if (wireBtn && self.root.contains(wireBtn)) { self.selectWire(+wireBtn.getAttribute('data-wire')); return; }

      if (e.target.closest('.qc-next')) { self.next(); return; }
      if (e.target.closest('.qc-prev')) { self.prev(); return; }
      if (e.target.closest('.qc-add-length')) { e.preventDefault(); self.addLengthRow(+e.target.closest('.qc-add-length').getAttribute('data-group')); return; }
      if (e.target.closest('.qc-remove-length')) { e.preventDefault(); e.target.closest('.qc-length-row').remove(); self.refresh(); return; }
      if (e.target.closest('.qc-add-cart')) { e.preventDefault(); self.addToCart(); return; }
      /* POC: "Email Quote" now routes to BSS B2B (its branded PDF/email) instead of
         Globo's Step 7. To restore Globo, swap submitToBss() back to goToStep(7). */
      if (e.target.closest('.qc-email-quote')) { e.preventDefault(); self.submitToBss(); return; }
      if (e.target.closest('.qc-submit')) { e.preventDefault(); self.submitQuote(); return; }

      var upsellBtn = e.target.closest('.qc-upsell-add');
      if (upsellBtn) { e.preventDefault(); self.addUpsell(upsellBtn); return; }
    });

    // Keyboard selection for card-style controls
    this.root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('[data-post],[data-layout],.qc-product');
      if (card && !card.classList.contains('qc-product--utility')) { e.preventDefault(); card.click(); }
    });

    // Numeric inputs
    this.root.addEventListener('input', function (e) {
      if (e.target.matches('.qc-input-height')) { self.onHeight(e.target.value); return; }
      if (e.target.matches('.qc-input-qty1')) { self.state.wireQty1 = parseInt(e.target.value, 10) || 0; self.refresh(); return; }
      if (e.target.matches('.qc-input-qty2')) { self.state.wireQty2 = parseInt(e.target.value, 10) || 0; self.refresh(); return; }
      if (e.target.matches('.qc-input-length1, .qc-input-length2')) { self.refresh(); return; }
    });
  };

  /* ---- Selection handlers (each resets everything downstream) ------------- */
  QuoteCalculator.prototype.selectPost = function (post) {
    this.state.post = post;
    this.reset(1);
    this.markSelected('[data-post]', '[data-post="' + post + '"]');
    // Timber + Metal (post 3) cannot use the auto calculator — original logic
    // forces the manual quote path: hide Next, show the request-a-quote notice.
    this.state.manualQuote = (post === 3);
    this.toggle('.qc-manual-quote', this.state.manualQuote);
    var step1Next = this.$('.qc-step[data-step="1"] .qc-next');
    if (step1Next) step1Next.hidden = this.state.manualQuote;
    this.refresh();
  };
  QuoteCalculator.prototype.selectLayout = function (layout) {
    this.state.layout = layout;
    this.reset(2);
    this.markSelected('[data-layout]', '[data-layout="' + layout + '"]');
    this.refresh();
  };
  QuoteCalculator.prototype.selectSystem = function (sku) {
    this.state.system = sku;
    this.reset(3);
    this.markSelected('.qc-product', '.qc-product[data-sku="' + sku + '"]');
    this.refresh();
  };
  QuoteCalculator.prototype.selectWire = function (wire) {
    this.reset(4);
    this.state.wire = wire;
    this.markSelected('[data-wire]', '[data-wire="' + wire + '"]');
    this.wireRegulation();
    this.refresh();
  };
  QuoteCalculator.prototype.onHeight = function (val) {
    var calc = (parseFloat(val) / 80) - this.state.wireSubtrahend;
    this.state.wireHeight = isNaN(calc) ? 0 : Math.ceil(calc);
    this.refresh();
  };

  QuoteCalculator.prototype.markSelected = function (groupSel, targetSel) {
    this.$$(groupSel).forEach(function (el) { el.classList.remove('is-selected'); });
    var t = this.$(targetSel);
    if (t) t.classList.add('is-selected');
  };
  QuoteCalculator.prototype.toggle = function (sel, show) {
    var el = this.$(sel);
    if (el) el.hidden = !show;
  };

  /* ---- reset cascade: clears everything at/after `level` ------------------ */
  QuoteCalculator.prototype.reset = function (level) {
    var s = this.state;
    if (level < 2) { this.$$('[data-layout]').forEach(function (e) { e.classList.remove('is-selected'); }); s.layout = 0; }
    if (level < 3) { this.$$('.qc-product').forEach(function (e) { e.classList.remove('is-selected'); }); s.system = ''; s.system2 = ''; }
    if (level < 4) {
      this.$$('[data-wire]').forEach(function (e) { e.classList.remove('is-selected'); });
      ['.qc-wire-height', '.qc-wire-qty', '.qc-wire-qty2'].forEach(function (sel) { var el = this.$(sel); if (el) el.hidden = true; }, this);
      var h = this.$('.qc-input-height'); if (h) h.value = '';
      var q1 = this.$('.qc-input-qty1'); if (q1) q1.value = '';
      var q2 = this.$('.qc-input-qty2'); if (q2) q2.value = '';
      s.wire = 0; s.wireHeight = 0; s.wireQty1 = 0; s.wireQty2 = 0;
    }
    if (level < 5) {
      this.$$('.qc-input-length1, .qc-input-length2').forEach(function (e) { e.value = ''; });
      this.$$('.qc-length-row.is-extra').forEach(function (e) { e.remove(); });
    }
  };

  /* ---- Combination resolution -------------------------------------------- */
  QuoteCalculator.prototype.pool = function () {
    return CONFIG.pools[this.state.post + '-' + this.state.layout] || [];
  };
  QuoteCalculator.prototype.reloadSystems = function () {
    this.state.wireSubtrahend = (this.state.layout === 2) ? 2 : 1;
    var pool = this.pool();
    this.$$('.qc-product').forEach(function (el) {
      if (el.classList.contains('qc-product--utility')) return;
      el.hidden = !inList(pool, el.getAttribute('data-sku'));
    });
  };
  QuoteCalculator.prototype.systemConditions = function () {
    var s = this.state;
    s.system2 = s.system;
    if (s.layout === 3 && CONFIG.stairPair[s.system]) s.system2 = CONFIG.stairPair[s.system];
  };
  QuoteCalculator.prototype.wireSku = function () {
    var sys = this.state.system;
    if (inList(CONFIG.customWire, sys))  return CONFIG.wireCustom;
    if (inList(CONFIG.customWire2, sys)) return CONFIG.wireCustom2;
    return CONFIG.wireDefault;
  };

  /* ---- Step 4 sub-section toggling --------------------------------------- */
  QuoteCalculator.prototype.wireRegulation = function () {
    var s = this.state, combo = (s.layout === 3);
    this.toggle('.qc-wire-height', s.wire === 1);
    this.toggle('.qc-wire-qty',  s.wire === 2);
    this.toggle('.qc-wire-qty2', s.wire === 2 && combo);

    var promptEl = this.$('.qc-wire-qty .qc-prompt');
    if (promptEl) promptEl.textContent = combo
      ? 'Enter the number of wires for your flat sections.'
      : 'Enter the number of wires you require per section.';

    // length-step second group + headings only for combo
    this.toggle('.qc-length-group2', combo);
    var h1 = this.$('.qc-length-heading1'), h2 = this.$('.qc-length-heading2');
    if (h1) { h1.hidden = !combo; h1.textContent = 'Flat System'; }
    if (h2) { h2.hidden = !combo; h2.textContent = 'Stair System'; }
  };

  /* ---- Instructional diagrams (steps 4 & 5) ------------------------------ */
  QuoteCalculator.prototype.wireHeightImage = function () {
    var L = this.state.layout;
    this.toggle('.qc-q4-1', L === 1 || L === 3); // handrail height (flat / combo)
    this.toggle('.qc-q4-2', L === 2 || L === 3); // stairs (stair / combo)
  };
  QuoteCalculator.prototype.wireLengthImage = function () {
    var s = this.state;
    var ttsFlat  = (s.system === 'WBS-TTS'  || s.system === 'WBSB-TTS');
    var ttsStair = (s.system2 === 'WBS-TTS' || s.system2 === 'WBS-TTSS' || s.system2 === 'WBSB-TTSS');
    var f1 = false, f2 = false, s3 = false, s4 = false;
    if (s.layout === 1) {
      if (ttsFlat) f2 = true; else f1 = true;
    } else if (s.layout === 2) {
      if (ttsStair) s4 = true; else s3 = true;
    } else if (s.layout === 3) {
      if (ttsFlat) f2 = true; else f1 = true;
      if (ttsStair) s4 = true; else s3 = true;
    }
    this.toggle('.qc-q5-1', f1); // flat inside-of-posts
    this.toggle('.qc-q5-2', f2); // flat outside-of-posts (TTS)
    this.toggle('.qc-q5-3', s3); // stair inside-to-inside
    this.toggle('.qc-q5-4', s4); // stair outside-to-outside (TTS)
  };

  /* ---- Wire count + validation (step 4) ---------------------------------- */
  QuoteCalculator.prototype.computeWire = function () {
    var s = this.state, valid = false;
    s.wire1 = 0; s.wire2 = 0;
    this.toggle('.qc-danger-h1', false);
    this.toggle('.qc-danger-h2', false);

    if (s.wire === 1) { // NCC auto by height
      var hasVal = !!(this.$('.qc-input-height') && this.$('.qc-input-height').value);
      if (s.layout < 3) {
        if (hasVal && s.wireHeight < 1) this.toggle(s.layout === 1 ? '.qc-danger-h1' : '.qc-danger-h2', true);
        if (s.wireHeight > 0) { s.wire1 = s.wireHeight; valid = true; }
      } else {
        if (hasVal && s.wireHeight < 2) this.toggle('.qc-danger-h2', true);
        if (s.wireHeight > 1) { s.wire1 = s.wireHeight; s.wire2 = s.wireHeight - 1; valid = true; }
      }
    } else if (s.wire === 2) { // manual
      if (s.layout < 3) {
        if (s.wireQty1 > 0) { s.wire1 = s.wireQty1; valid = true; }
      } else if (s.wireQty1 > 0 && s.wireQty2 > 0) {
        s.wire1 = s.wireQty1; s.wire2 = s.wireQty2; valid = true;
      }
    }

    // mirror resolved counts into the length-row labels
    this.$$('.qc-wireqty1').forEach(function (el) { el.textContent = s.wire1; });
    this.$$('.qc-wireqty2').forEach(function (el) { el.textContent = s.wire2; });
    return valid;
  };

  /* ---- Length validation (step 5) ---------------------------------------- */
  QuoteCalculator.prototype.maxLength = function () {
    return inList(CONFIG.shortMax, this.state.system) ? CONFIG.LENGTH_MAX_SHORT : CONFIG.LENGTH_MAX;
  };
  QuoteCalculator.prototype.validateLengths = function () {
    var self = this, max = this.maxLength(), ok = true, any = false;
    this.$$('.qc-maxval').forEach(function (el) { el.textContent = max; });
    var groups = this.state.layout === 3 ? ['.qc-input-length1', '.qc-input-length2'] : ['.qc-input-length1'];

    groups.forEach(function (sel) {
      self.$$(sel).forEach(function (input) {
        var row = input.closest('.qc-length-row');
        if (row) row.classList.remove('has-min-error', 'has-max-error');
        var v = parseFloat(input.value);
        if (!v || v <= 0) { ok = false; return; }
        any = true;
        if (v <= CONFIG.LENGTH_MIN) { ok = false; if (row) row.classList.add('has-min-error'); }
        else if (v > max) { ok = false; if (row) row.classList.add('has-max-error'); }
      });
    });

    // expose the active max to the message via data attribute
    this.root.setAttribute('data-max-length', max);
    return ok && any;
  };

  /* ---- Pricing / line-item build (calculator) ---------------------------- */
  QuoteCalculator.prototype.calculator = function () {
    var self = this, s = this.state;
    var sumQty1 = 0, sumWire1 = 0, sumQty2 = 0, sumWire2 = 0;
    var lens1 = [], lens2 = [];   // section lengths (mm) actually entered — feed the notes

    this.$$('.qc-input-length1').forEach(function (input) {
      var v = parseFloat(input.value);
      if (v > 0) { sumQty1 += s.wire1; sumWire1 += s.wire1 * (v / 1000); lens1.push(v); }
    });
    if (s.layout === 3) {
      this.$$('.qc-input-length2').forEach(function (input) {
        var v = parseFloat(input.value);
        if (v > 0) { sumQty2 += s.wire2; sumWire2 += s.wire2 * (v / 1000); lens2.push(v); }
      });
    }

    var sumSwaging = (s.layout < 3 ? sumQty1 : sumQty1 + sumQty2) * 2;
    if (inList(CONFIG.noSwaging, s.system)) sumSwaging = 0;
    var wireMetres = Math.floor(sumWire1 + sumWire2);
    var wireSku = this.wireSku();

    // Per-product measurement notes, built from the same Step 4/5 inputs.
    var notes = this.buildNotes(lens1, lens2, sumQty1, sumQty2, sumSwaging, wireMetres);
    // Structured whole-quote summary for the BSS quote note (see applyBssNotes).
    this.measurementSummary = notes.summary;

    var items = [];
    if (s.layout === 3) {
      if (sumQty1 > 0) items.push(this.lineItem(s.system,  this.nameOf(s.system)  + ' (Flat)',   sumQty1, notes.system1));
      if (sumQty2 > 0) items.push(this.lineItem(s.system2, this.nameOf(s.system2) + ' (Stairs)', sumQty2, notes.system2));
    } else if (sumQty1 > 0) {
      items.push(this.lineItem(s.system, this.nameOf(s.system), sumQty1, notes.system1));
    }
    if (sumSwaging > 0) items.push(this.lineItem(CONFIG.swaging, this.nameOf(CONFIG.swaging), sumSwaging, notes.swaging));
    if (wireMetres > 0) items.push(this.lineItem(wireSku, this.nameOf(wireSku), wireMetres, notes.wire));

    this.lineItems = items;
  };

  /* ---- Measurement notes (verbalise the Step 4/5 derivation) -------------- */
  QuoteCalculator.prototype.buildNotes = function (lens1, lens2, sumQty1, sumQty2, sumSwaging, wireMetres) {
    var s = this.state;

    // Wire-count basis — how the wires-per-section figure was arrived at.
    var h = '';
    if (s.wire === 1) {
      var hEl = this.$('.qc-input-height');
      h = hEl && hEl.value ? hEl.value : '';
    }
    var basisParen;   // short reason, e.g. "900mm handrail" / "NCC" / "manual"
    if (s.wire === 1) {
      basisParen = h ? h + 'mm handrail' : 'NCC';
    } else {
      basisParen = 'manual';
    }

    function lenList(arr) { return arr.join('mm, ') + 'mm'; }
    function sectionWord(n) { return n === 1 ? 'section' : 'sections'; }
    var totalRuns = s.layout < 3 ? sumQty1 : sumQty1 + sumQty2;

    /* ---- Per-product one-liners (cart "Measurements:" row) ---- */
    function systemNote(label, lens, wires) {
      return label + ': ' + lens.length + ' ' + sectionWord(lens.length) +
        ' (' + lenList(lens) + '), ' + wires + ' wires each (' + basisParen + ')';
    }

    var out = { system1: '', system2: '', swaging: '', wire: '', summary: '' };

    if (s.layout === 3) {
      if (lens1.length) out.system1 = systemNote('Flat',  lens1, s.wire1);
      if (lens2.length) out.system2 = systemNote('Stairs', lens2, s.wire2);
    } else if (lens1.length) {
      out.system1 = systemNote(s.layout === 2 ? 'Stairs' : 'Flat', lens1, s.wire1);
    }

    if (sumSwaging > 0) out.swaging = '2 per wire run (' + totalRuns + ' runs)';
    if (wireMetres > 0) out.wire = wireMetres + 'm total';

    /* ---- Simple whole-quote summary (BSS quote — one note per quote) ---- */
    var result = [];
    var L = ['Measurements (from customer):'];
    if (s.layout === 3) {
      if (lens1.length) L.push('Flat: ' + lenList(lens1) + ' - ' + s.wire1 + ' wires each = ' + sumQty1 + ' systems');
      if (lens2.length) L.push('Stairs: ' + lenList(lens2) + ' - ' + s.wire2 + ' wires each = ' + sumQty2 + ' systems');
      L.push('Wire count: ' + basisParen);
    } else {
      if (lens1.length) {
        L.push('Sections: ' + lenList(lens1));
        L.push('Wires: ' + s.wire1 + ' per section (' + basisParen + ')');
        result.push(sumQty1 + ' systems');
      }
    }
    if (sumSwaging > 0) result.push(sumSwaging + ' swage fittings');
    if (wireMetres > 0) result.push(wireMetres + 'm wire');
    if (result.length) L.push('Result: ' + result.join(', '));
    out.summary = L.join('\n');

    return out;
  };
  QuoteCalculator.prototype.lineItem = function (sku, name, qty, note) {
    var info = this.skuMap[sku] || {};
    var unit = info.price || 0;
    var compare = info.comparePrice || unit;
    return {
      sku: sku, name: name, qty: qty, unit: unit, total: qty * unit,
      comparePrice: compare, image: info.image || '', variantId: info.variantId || null,
      productId: info.productId || null,
      note: note || ''
    };
  };

  /* ---- Render summary table (step 6) ------------------------------------- */
  QuoteCalculator.prototype.renderOutput = function () {
    var tbody = this.$('.qc-summary-body');
    if (!tbody) return;
    var gst = this.gstLabel || 'Inc GST';
    var mul = this.gstMul || 1;   /* display-only: retail prices shown × 1.1 */
    var grand = 0, grandCompare = 0;
    tbody.innerHTML = this.lineItems.map(function (it) {
      grand        += it.total;
      grandCompare += it.comparePrice * it.qty;
      var hasDiscount = it.comparePrice > it.unit;
      var priceCell = hasDiscount
        ? '<s class="qc-summary-compare">' + money(it.comparePrice * mul) + '</s><br>' + money(it.unit * mul) + ' <span class="qc-gst">' + gst + '</span>'
        : money(it.unit * mul) + ' <span class="qc-gst">' + gst + '</span>';
      return '<tr>' +
        '<td class="qc-summary-img">' + thumbCell(it.image) + '</td>' +
        '<td class="qc-cell-desc">' + it.name + '</td>' +
        '<td class="qc-cell-num">' + it.qty + '</td>' +
        '<td class="qc-cell-num">' + priceCell + '</td>' +
        '<td class="qc-cell-num">' + money(it.total * mul) + '</td>' +
      '</tr>';
    }).join('');

    var totalEl = this.$('.qc-summary-total');
    if (totalEl) totalEl.innerHTML = money(grand * mul) + ' <span class="qc-gst">' + gst + '</span>';

    var savings = grandCompare - grand;
    var savingsRow = this.$('.qc-summary-savings-row');
    var savingsEl  = this.$('.qc-summary-savings');
    if (savingsRow) savingsRow.hidden = savings <= 0;
    if (savingsEl && savings > 0) savingsEl.innerHTML = money(savings * mul);

    var empty = this.lineItems.length === 0;
    var addBtn = this.$('.qc-add-cart');
    if (addBtn) addBtn.disabled = empty;
    var emailBtn = this.$('.qc-email-quote');
    if (emailBtn) emailBtn.disabled = empty;
    this.toggle('.qc-summary-empty', empty);
  };

  /* ---- Per-step validity + nav state ------------------------------------- */
  QuoteCalculator.prototype.stepValid = function (step) {
    var s = this.state;
    switch (step) {
      case 1: return s.post > 0 && !s.manualQuote;
      case 2: return s.layout > 0;
      case 3: return !!s.system;
      case 4: return this.computeWire();
      case 5: return this.validateLengths();
      default: return true;
    }
  };
  QuoteCalculator.prototype.updateNav = function () {
    var self = this;
    this.$$('.qc-step').forEach(function (stepEl) {
      var step = +stepEl.getAttribute('data-step');
      var next = stepEl.querySelector('.qc-next');
      if (next) next.disabled = !self.stepValid(step);
    });
  };

  /* ---- Orchestration ----------------------------------------------------- */
  QuoteCalculator.prototype.refresh = function () {
    this.reloadSystems();
    this.systemConditions();
    this.wireHeightImage();
    this.computeWire();
    this.wireLengthImage();
    this.calculator();
    this.renderOutput();
    this.updateNav();
  };

  /* ---- Step navigation --------------------------------------------------- */
  QuoteCalculator.prototype.goToStep = function (step) {
    step = Math.max(1, Math.min(CONFIG.TOTAL_STEPS, step));
    var self = this;
    var prevStep = this.state.step;
    this.state.step = step;

    this.$$('.qc-progress-step').forEach(function (el) {
      var n = +el.getAttribute('data-step');
      el.classList.toggle('is-active', n === step);
      el.classList.toggle('is-done', n < step);
    });

    window.scrollTo({
      top: this.root.getBoundingClientRect().top + window.pageYOffset - 20,
      behavior: 'smooth'
    });

    var allSteps = this.$$('.qc-step');
    var outgoing  = this.$('.qc-step[data-step="' + prevStep + '"]');
    var incoming  = this.$('.qc-step[data-step="' + step    + '"]');

    /* Generation counter — invalidates callbacks from any interrupted transition */
    this._stepGen = (this._stepGen || 0) + 1;
    var gen = this._stepGen;

    /* Reset: strip animation classes; hide everything except the currently visible step */
    allSteps.forEach(function (el) {
      el.classList.remove('is-leaving', 'is-entering');
      if (el !== outgoing) el.hidden = true;
    });

    function animateIn(el) {
      el.hidden = false;
      void el.offsetWidth; /* reflow — ensures animation starts fresh */
      el.classList.add('is-entering');
      el.addEventListener('animationend', function () {
        if (self._stepGen !== gen) return;
        el.classList.remove('is-entering');
      }, { once: true });
    }

    if (!outgoing || prevStep === step) {
      if (incoming) animateIn(incoming);
      return;
    }

    outgoing.classList.add('is-leaving');
    outgoing.addEventListener('animationend', function () {
      if (self._stepGen !== gen) return;
      outgoing.classList.remove('is-leaving');
      outgoing.hidden = true;
      if (incoming) animateIn(incoming);
    }, { once: true });
  };
  QuoteCalculator.prototype.next = function () {
    if (!this.stepValid(this.state.step)) return;
    this.goToStep(this.state.step + 1);
  };
  QuoteCalculator.prototype.prev = function () { this.goToStep(this.state.step - 1); };

  /* ---- Dynamic length rows ----------------------------------------------- */
  QuoteCalculator.prototype.addLengthRow = function (group) {
    var container = this.$('.qc-length-group' + group + ' .qc-length-rows');
    if (!container) return;
    var qty = group === 2 ? this.state.wire2 : this.state.wire1;
    var cls = group === 2 ? 'qc-input-length2' : 'qc-input-length1';
    var lbl = group === 2 ? 'qc-wireqty2' : 'qc-wireqty1';
    var row = document.createElement('div');
    row.className = 'qc-length-row is-extra';
    row.innerHTML =
      '<input type="number" class="qc-input ' + cls + '" placeholder="0" min="0">' +
      '<span class="qc-length-unit">mm &times; <span class="' + lbl + '">' + qty + '</span></span>' +
      '<button type="button" class="qc-remove-length" aria-label="Remove length">&times;</button>' +
      '<p class="qc-error qc-error-min">Minimum length for this system is 400&nbsp;mm</p>' +
      '<p class="qc-error qc-error-max">Maximum length for this system is <span class="qc-maxval"></span>&nbsp;mm</p>';
    container.appendChild(row);
    this.refresh();
  };

  /* ---- Add all quote items to cart --------------------------------------- */
  QuoteCalculator.prototype.addToCart = function () {
    // one cart line per quote item, each carrying its own measurement note as a
    // line-item property. Shopify merges lines that share a variant AND property set,
    // so a combo's flat/stair lines (same SKU, different notes) stay separate — which
    // is the intended, more descriptive behaviour.
    var items = [], missing = [];
    this.lineItems.forEach(function (it) {
      if (it.qty <= 0) return;
      if (!it.variantId) { missing.push(it.sku); return; }
      var item = { id: Number(it.variantId), quantity: it.qty };
      if (it.note) item.properties = { 'Measurements': it.note };
      items.push(item);
    });

    if (missing.length) {
      this.notify('Some products are unavailable in the store (' + missing.join(', ') + '). Please contact support.', true);
      return;
    }
    if (!items.length) return;

    var btn = this.$('.qc-add-cart');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var self = this;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (data) {
        // Stay on the quote page — confirm with a toast and refresh the header badge.
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (window.AWRCart) {
          window.AWRCart.added(data, { source: 'quote-calculator' });
        } else {
          self.notify('Added to cart.');
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        self.notify('Unable to add items to cart. Please try again.', true);
      });
  };

  /* ---- POC: send the calculator quote to BSS B2B (instead of Globo) --------
     Pushes the calculator's line items into BSS's own `r4qVariants` localStorage
     and fires BSS's `bcpR4q:addItemsSuccess` event to open its Request For Quote
     modal — so BSS generates its branded quote PDF/email. The Globo path
     (submitQuote / Step 7) is left intact for an easy revert.                   */
  QuoteCalculator.prototype.submitToBss = function () {
    var items = this.lineItems
      .filter(function (it) { return it.qty > 0 && it.variantId && it.productId; })
      .map(function (it) {
        return {
          productId: it.productId,
          variantId: String(it.variantId),
          quotedPrice: it.unit,        // already the discounted per-unit price (dollars)
          quantity: it.qty,
          note: it.note || ''          // kept for reference; BSS ignores unknown keys. The note reaches BSS's "Product note" field via applyBssNotes() DOM injection.
        };
      });

    if (!items.length) {
      this.notify('No quotable items to send. Please complete your quote first.', true);
      return;
    }

    // Unknown #1: is BSS B2B even initialised on this (non-product) page?
    if (!(window.BSS_BCP_V2 && window.BSS_BCP_V2.r4q)) {
      console.warn('[QuoteCalculator] BSS B2B (BSS_BCP_V2) not detected on this page — cannot open its quote modal.');
      this.notify('The quote system is not available on this page. Please contact us to complete your quote.', true);
      return;
    }

    try {
      var existing = JSON.parse(localStorage.getItem('r4qVariants') || '[]');
      localStorage.setItem('r4qVariants', JSON.stringify(existing.concat(items)));
    } catch (e) {
      localStorage.setItem('r4qVariants', JSON.stringify(items));
    }

    document.head.dispatchEvent(new CustomEvent('bcpR4q:addItemsSuccess', { bubbles: true, composed: true }));

    /* Auto-open BSS's quote modal so the customer goes straight there, instead of
       leaving the "added to Quote Request List" toast for them to click. The floating
       quote widget button lives inside the <bcp-r4q-widget-main> OPEN shadow root;
       clicking it opens the quote request view. Retry briefly in case BSS renders the
       widget a moment after the event fires. */
    var tries = 0;
    (function openBssModal() {
      var widget = document.querySelector('bcp-r4q-widget-main');
      var btn = (widget && widget.shadowRoot) ? widget.shadowRoot.querySelector('button') : null;
      if (btn) { btn.click(); return; }
      if (++tries < 20) setTimeout(openBssModal, 150);
    })();

    /* BSS has no supported way to pre-fill the per-product "Product note" via
       r4qVariants (confirmed by their support), so we inject each line's
       measurement note into the modal's textarea directly. The modal renders a
       moment after the event above, and rows can appear one at a time, so poll
       briefly and re-apply — applyBssNotes() is idempotent. */
    var self = this, noteTries = 0;
    (function applyNotes() {
      self.applyBssNotes();
      if (++noteTries < 20) setTimeout(applyNotes, 200);
    })();
  };

  /* ---- Inject the measurement notes into BSS's quote modal ----------------
     Each quoted row is a <bcp-r4q-line-item> custom element with its OWN open
     shadow root, holding a `.bcp-r4q-line-item-note` textarea. BSS, however,
     persists only ONE product note per quote (last write wins) — the per-line
     textareas are cosmetic in their data model, so per-line notes can't survive
     submit. We therefore consolidate every line's measurement note into a single
     labelled block and write that SAME block into every textarea: whichever one
     BSS keeps, the sales team receives the full breakdown.

     BSS is built on Lit, so we set the value via the native setter and fire
     input/change (so BSS records it into component state — a plain assignment
     would be wiped on the next re-render), and mark the field readOnly, NOT
     disabled (a disabled textarea's value is not submitted). Defensive by
     design: it walks nested shadow roots and relies on BSS-internal class names,
     so it silently no-ops if BSS changes its markup. Cart path is unaffected.   */
  QuoteCalculator.prototype.applyBssNotes = function () {
    // maxlength on the field is 500; keep the block within it so nothing is cut.
    var combined = (this.measurementSummary || '').slice(0, 500);
    if (!combined) return;

    var setValue = Object.getOwnPropertyDescriptor(
      window.HTMLTextAreaElement.prototype, 'value'
    ).set;

    function fill(ta) {
      if (ta.value !== combined) {
        setValue.call(ta, combined);
        ta.dispatchEvent(new Event('input', { bubbles: true }));
        ta.dispatchEvent(new Event('change', { bubbles: true }));
      }
      ta.readOnly = true;
      ta.removeAttribute('disabled');
      // Read-only visual cue (theme CSS can't reach inside BSS's shadow DOM).
      ta.style.background = '#f4f4f5';
      ta.style.color = '#3f3f46';
      ta.style.cursor = 'not-allowed';
    }

    // Collect every note textarea, walking nested shadow roots.
    function collect(root, acc) {
      if (!root || !root.querySelectorAll) return acc;
      Array.prototype.forEach.call(root.querySelectorAll('.bcp-r4q-line-item-note'), function (ta) {
        if (acc.indexOf(ta) === -1) acc.push(ta);
      });
      Array.prototype.forEach.call(root.querySelectorAll('*'), function (el) {
        if (el.shadowRoot) collect(el.shadowRoot, acc);
      });
      return acc;
    }

    collect(document, []).forEach(function (ta) {
      fill(ta);
      // Re-apply if BSS re-renders the row (e.g. quantity change). Once per node.
      if (!ta._qcNoteObserved) {
        ta._qcNoteObserved = true;
        try {
          new MutationObserver(function () { fill(ta); })
            .observe(ta.getRootNode(), { childList: true, subtree: true });
        } catch (e) {}
      }
    });
  };

  /* ---- Submit quote via the hidden Globo Form Builder (original logic) ---- */
  QuoteCalculator.prototype.submitQuote = function () {
    var nameEl = this.$('#quote-name');
    var emailEl = this.$('#quote-email');
    var customerName = nameEl ? nameEl.value.trim() : '';
    var customerEmail = emailEl ? emailEl.value.trim() : '';
    if (!customerName || !customerEmail) {
      this.notify('Please enter your name and email address.', true);
      return;
    }

    // Build the column lists from the quote line items
    var mul = this.gstMul || 1;   /* display-only: retail quote prices shown × 1.1 */
    var descs = [], qtys = [], prices = [], totals = [], grand = 0;
    this.lineItems.forEach(function (it) {
      grand += it.total;
      descs.push(it.name);
      qtys.push(String(it.qty));
      prices.push(money(it.unit * mul));
      totals.push(money(it.total * mul));
    });

    // Wire counts + section lengths (plain text), mirroring the legacy output
    var s = this.state, wireLines = [], sectionLines = [];
    if (s.layout === 1) { wireLines.push('Flat Section: ' + s.wire1 + ' x wires'); }
    else if (s.layout === 2) { wireLines.push('Stair Section: ' + s.wire1 + ' x wires'); }
    else if (s.layout === 3) {
      wireLines.push('Flat Section: ' + s.wire1 + ' x wires');
      wireLines.push('Stair Section: ' + s.wire2 + ' x wires');
    }
    this.$$('.qc-input-length1').forEach(function (i) {
      if (parseFloat(i.value) > 0) sectionLines.push('Flat Section: ' + i.value + 'mm x ' + s.wire1);
    });
    this.$$('.qc-input-length2').forEach(function (i) {
      if (parseFloat(i.value) > 0) sectionLines.push('Stair Section: ' + i.value + 'mm x ' + s.wire2);
    });

    // Resolve the Globo field prefix from the form's base64 data-id (MTEyODQ2 -> 112846)
    var wrap = this.$('.qc-globo');
    var dataId = wrap ? wrap.getAttribute('data-globo-id') : '';
    var prefix = '112846';
    try { if (dataId) prefix = atob(dataId); } catch (e) { /* keep default */ }

    function setById(suffix, val) { var el = document.getElementById(prefix + suffix); if (el) el.value = val; }
    setById('-text-1', customerName);     // Name
    setById('-email-2', customerEmail);   // Email
    setById('-text-3', descs.join('\n')); // Descriptions
    setById('-text-4', qtys.join('\n'));  // Quantities
    setById('-text-5', prices.join('\n'));// Prices
    setById('-text-10', totals.join('\n'));// Totals
    setById('-text-2', money(grand * mul));     // Grand total
    setById('-text-6', wireLines.join('\n'));    // Wires
    setById('-text-7', sectionLines.join('\n')); // Section lengths

    // Globo may also expect generic customer inputs
    if (wrap) {
      var cN = wrap.querySelector('input[name="customer[name]"]'); if (cN) cN.value = customerName;
      var cE = wrap.querySelector('input[name="customer[email]"]'); if (cE) cE.value = customerEmail;
    }

    // Submit the Globo form
    var globoForm = wrap ? wrap.querySelector('form') : null;
    var globoSubmit = globoForm ? globoForm.querySelector('button[type="submit"], .wizard__submit') : null;
    if (globoSubmit) { globoSubmit.click(); this.showThankYou(); return; }
    if (globoForm) { globoForm.submit(); this.showThankYou(); return; }

    this.notify('The quote form is currently unavailable. Please try again shortly or contact us directly.', true);
  };

  QuoteCalculator.prototype.showThankYou = function () {
    var self = this;
    setTimeout(function () {
      self.toggle('.qc-email-form', false);
      var ty = self.$('.qc-thankyou'); if (ty) ty.hidden = false;
      var submit = self.$('.qc-submit'); if (submit) submit.hidden = true;
    }, 800);
  };

  /* ---- Add a single intermediate-post upsell item to cart ---------------- */
  QuoteCalculator.prototype.addUpsell = function (btn) {
    var id = Number(btn.getAttribute('data-variant-id'));
    if (!id) return;
    var row = btn.closest('.qc-upsell-row');
    var qtyInput = row ? row.querySelector('.qc-upsell-qty') : null;
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    var label = btn.textContent;
    btn.disabled = true; btn.classList.add('is-loading');
    var self = this;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';
        if (window.AWRCart) window.AWRCart.added(data, { source: 'quote-calculator-upsell' });
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = label; }, 2000);
      })
      .catch(function () {
        btn.disabled = false; btn.classList.remove('is-loading');
        self.notify('Unable to add this item to cart. Please try again.', true);
      });
  };

  QuoteCalculator.prototype.notify = function (msg, isError) {
    var stepEl = this.$('.qc-step[data-step="' + this.state.step + '"]');
    var el = (stepEl && stepEl.querySelector('.qc-notice')) || this.$('.qc-notice');
    if (!el) { if (isError) alert(msg); return; }
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
  };

  /* ---- Intro modal (shown on load; close via X / overlay / button / Esc) -- */
  function initModals() {
    document.querySelectorAll('.qc-modal[data-qc-modal]').forEach(function (modal) {
      if (modal.__qcModal) return;
      modal.__qcModal = true;

      function open()  { modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; document.body.classList.add('qc-modal-open'); }
      function close() { modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; document.body.classList.remove('qc-modal-open'); }

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-qc-modal-close]')) { e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });

      open();
    });
  }

  /* ---- Boot -------------------------------------------------------------- */
  function init() {
    document.querySelectorAll('.quote-calculator').forEach(function (root) {
      if (!root.__qc) root.__qc = new QuoteCalculator(root);
    });
    initModals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
